/**
 * @name Lazy Load
 * @author PLEJ
 */

'use strict';
const lazyBg = (() => {
    let images = [], iObserver, extension;
    const selector = '[data-lazy-bg]', sUsrAg = navigator.userAgent;

    const config = {
        rootMargin: '300px 0px',
        threshold: 0.01
    };

    /**
     * @function Init
     */
    const init = () => {
        initEvents();

        document.querySelectorAll(selector).forEach(getElement);

        new (window.MutationObserver || window.WebKitMutationObserver)(
            (mutationList) => {
                mutationList.forEach(
                    ( mutation ) => mutation.addedNodes.forEach( (elem) => {
                        if (!elem || !elem.matches ) return;

                        if (elem.matches(selector))
                            return getElement(elem);

                        elem.querySelectorAll(selector).forEach(getElement);
                    } )
                )
            }
        ).observe(
            document.body,
            {
                childList : true,
                subtree: true
            }
        );
    };

    /**
     * @function Init Events
     */
    const initEvents = () => {
        // checkBrowser();

        if ('IntersectionObserver' in window) {
            iObserver = new IntersectionObserver(handleIntersection, config);
        } else {
            window.addEventListener('scroll', ()=> {
                images.forEach(image => checkSingle(image));
            });
        }
    };

    /**
     * Get elements
     * @param {object} element
     */
    const getElement = (element) => {
        images.push(element);

        if ('IntersectionObserver' in window) {
            iObserver.observe(element);
        } else {
            checkSingle(element);
        }
    };

    /**
     * Load image
     * @param {object} image
     */
    const loadImage = (image) => {
        const src = image.dataset.lazyBg;
        if (!src) return;

        const bgs = src.split(",");

        bgs.forEach(bg => setVariable(bg, image));

        image.removeAttribute('data-lazy-bg');
    };

    /**
     * @desc set variable with bg image for document
     * @param {string} string with image url and variable name
     */
    const setVariable = (string, image) => {
        const bg = string.split("|");
        let url = bg[0];

        if(extension) {
            const temp = url.split(".");
            const ext = temp[temp.length - 1];
            url = url.slice(0,-ext.length) + extension;
        }

        // document.documentElement.style.setProperty("--"+bg[1], "url('"+url.trim()+"')");
        image.style.setProperty("--"+bg[1], "url('"+url.trim()+"')");
    };

    /**
     * @desc check browser
     * https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
     */
    const checkBrowser = () => {
        if (sUsrAg.indexOf("Firefox") > -1) {
            extension = "";
            // Mozilla Firefox
        } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
            extension = "";
            // Samsung Internet
        } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
            extension = "";
            // Opera
        } else if (sUsrAg.indexOf("Trident") > -1) {
            extension = "";
            // Microsoft Internet Explorer
        } else if (sUsrAg.indexOf("Edge") > -1) {
            extension = "";
            // Microsoft Edge
        } else if (sUsrAg.indexOf("Chrome") > -1) {
            extension = "webp";
            // Google Chrome or Chromium
        } else if (sUsrAg.indexOf("CriOS") > -1) {
            extension = "";
            // Google Chrome on IOS
        } else if (sUsrAg.indexOf("Safari") > -1) {
            extension = "";
            // Apple Safari
        } else {
            extension = "";
            //unknown
        }
    };

    /**
     * Handle intersection
     * @param {array} entries
     */
    const handleIntersection = (entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                iObserver.unobserve(entry.target);
                loadImage(entry.target);
            }
        });
    };

    /**
     * @desc Check position single image
     */
    const _checkPosition = (image) => {
        return image.getBoundingClientRect().top * 0.3 <= window.innerHeight;
    };

    /**
     * Check single
     * @desc check single element when document load
     * @param {array} element
     */
    const checkSingle = (image) => {
        if (_checkPosition(image)) {
            loadImage(image);
        }
    };

    return {
        init: init
    };
})();

export {lazyBg}